export default {
  common: {
    login: '登陆',
    signup: '注册',
    usd: '美元',
    agentid: '代理账号',
    logout: '退出',
    liveTime: '24/7 全天候协助',
    callUs: '联系我们',
    followUs: '关注我们',
    payMethods: '支付方式',
    copyright: '版权所有',
    policy: '政策',
    membership: '会员',
    subscribe: '订阅',
    unsubscribe: '取消订阅',
    showMore: '显示更多',
    showLess: '显示更少',
    months: {
      jan: '1月',
      feb: '2月',
      mar: '3月',
      apr: '4月',
      may: '5月',
      jun: '6月',
      jul: '7月',
      aug: '8月',
      sep: '9月',
      oct: '10月',
      nov: '11月',
      dec: '12月'
    },
    longMonths: {
      jan: '1月',
      feb: '2月',
      mar: '3月',
      apr: '4月',
      may: '5月',
      jun: '6月',
      jul: '7月',
      aug: '8月',
      sep: '9月',
      oct: '10月',
      nov: '11月',
      dec: '12月'
    },
    reset: '重置',
    confirm: '确认',
    flightIncluded: '包含航班',
    somethingWrong: '出现错误',
    moreThan: '多于',
    more: '更多',
    year: '年',
    month: '月',
    days: '天',
    hour: '小时',
    hours: '小时',
    mins: '分钟',
    secs: '秒',
    nights: '晚',
    person: '人',
    points: '积分',
    tours: '旅游',
    packages: '套餐',
    hotels: '酒店',
    flights: '机票',
    flight: '机票',
    attractions: '景点',
    cruises: '邮轮',
    cruise: '邮轮',
    search: '查询',
    tourOnly: '仅行程',
    from: '从',
    off: '折扣',
    independent: '独立旅行',
    semiGuided: '半自助游',
    escorted: '全程陪同',
    luxury: '豪华',
    semiEscorted: '半陪同',
    close: '关闭',
    closeWindow: '关闭窗口',
    email: '邮箱',
    password: '密码',
    cantEmpty: '不能为空',
    enterEmail: '请填写正确的邮箱',
    emailAddress: '邮箱地址',
    enterName: '请输入正确的姓名',
    enterCorrectPhone: '请输入正确的电话号码',
    firstName: '名字',
    lastName: '姓氏',
    phone: '电话',
    phoneNumber: '电话号码',
    verification: '验证',
    verificationCode: '验证码',
    verified: '已验证',
    resend: '重新发送',
    getCode: '获取验证码',
    confirmPassword: '确认密码',
    SUCCESSFUL: '成功',
    share: '分享',
    save: '收藏',
    groupSize: '团队规模',
    tourCode: '旅游代码',
    included: '包含',
    excluded: '不包含',
    destinationConcierge: '目的地礼宾服务',
    age: '年龄',
    operatedIn: '运营语言',
    operator: '运营商',
    curatedBy: 'TripToGo 精选',
    firstGlance: '快速浏览',
    day: '天',
    night: '晚',
    breakfast: '早餐',
    lunch: '午餐',
    dinner: '晚餐',
    englishS: '',
    englishEs: '',
    includedActivities: '包含活动',
    readMore: '阅读更多',
    readLess: '收起',
    hideDetails: '隐藏详情',
    stars: '星级',
    wiFiNotIncluded: '不包含Wi-Fi',
    additionalFeatures: '额外特色',
    details: '详情',
    detail: '详情',
    travelDocumentVisas: '旅行文件与签证',
    travelersReviews: '旅行者评价',
    addReview: '添加评价',
    reviews: '评价',
    newest: '最新',
    oldest: '最早',
    highest: '最高评分',
    lowest: '最低评分',
    showMoreReviews: '显示更多评价',
    documentVisas: '文件与签证',
    operatorPolicy: '运营商政策',
    priceWas: '原价',
    now: '现价',
    dayOrder1: '第',
    dayOrder2: '天',
    wiFiIncluded: '包含Wi-Fi',
    freeCable: '免费有线电视',
    cableFee: '收费有线电视',
    accommodation: '住宿',
    transportation: '交通',
    guidedTour: '导览游',
    withAdditionalFeatures: '包含额外特色',
    internationalAirfare: '国际机票',
    airfare: '机票',
    withDomesticFlight: '包含国内航班',
    meals: '餐饮',
    specialLodge: '特色旅馆',
    localbest: '本地最好',
    english: '英语',
    mostRecent: '最新',
    sun: '周日',
    mon: '周一',
    tue: '周二',
    wed: '周三',
    thu: '周四',
    fri: '周五',
    sat: '周六',
    depart: '出发',
    start: '开始',
    return: '返回',
    end: '结束',
    dates: '日期',
    bestPrice: '最佳价格',
    priceDrop: '降价',
    cancel: '取消',
    departureCity: '出发城市',
    yearExt: '年',
    dayExt: '日',
    duration: '时长',
    departureDate: '出发日期',
    tourStarts: '行程开始',
    returnDate: '返回日期',
    tourEnds: '行程结束',
    rooms: '房间',
    room: '房间',
    continue: '继续',
    adults: '成人',
    ages18OrAbove: '18 岁及以上',
    ages3_17: '3 - 17 岁',
    children: '儿童',
    confirmChanges: '确认更改',
    traveler: '游客',
    travelers: '游客',
    travelerUnit: '个',
    submit: '提交',
    somethingError: '出现错误！',
    ages12OrAbove: '12岁及以上',
    ages3_11: '3 - 11岁',
    pleaseSelect: '请选择',
    register: '注册',
    tripToGo: 'TripToGo',
    account: '账户',
    telephone: '电话',
    name: '姓名',
    gender: '性别',
    surname: '姓',
    givenName: '名',
    male: '男(M)',
    female: '女(F)',
    undisclosed: '未公开(U)',
    unspecified: '未指定(X)',
    birthday: '生日',
    MM: '月',
    DD: '日',
    YYYY: '年',
    address: '地址',
    edit: '编辑',
    country: '国家',
    province: '州/省',
    city: '城市',
    postalCode: '邮政编码',
    selectCountry: '选择国家',
    copy: '复制',
    copied: '已复制',
    people: '人',
    description: '描述',
    status: '状态',
    invalidDate: '无效日期',
    back: '返回',
    expired: '已过期',
    copiedSuccessfully: '复制成功',
    shareedSuccessfully: '分享成功',
    url: '网址',
    formSave: '保存',
    other: '其它'
  },
  menu: {
    newsletter: '通讯',
    network: '网络推广',
    mystory: '我的故事',
    shareJourney: '故事讲述者计划',
    myinquiry: '我的咨询',
    mywallet: '我的钱包',
    mybookings: '我的预订',
    myVouchers: '我的酒店券',
    Wishlist: '我的收藏',
    personal: '个人信息',
    promotion: '促销',
    commission: '佣金',
    cashback: '联盟计划',
    partner: '合作伙伴',
    company: '关于公司',
    aboutUs: '关于我们',
    largeGroupPartnership: '大型团队合作',
    partneringWith: '与 TripToGo 合作',
    workingWith: '与 TripToGo 合作',
    operatorPortal: '运营商门户',
    operatorRegistration: '运营商注册',
    agentsLogIn: '代理商登录',
    agentRegistration: '代理商注册',
    agentFAQ: '代理商常见问题',
    contactUs: '联系我们',
    agentContactUs: '旅行社专属',
    travelInsurance: '旅行保险',
    travelProtection: '旅行保障',
    general: '通用',
    privacy: '隐私',
    fefund: '退款',
    cookies: 'Cookies',
    joinNow: '立即加入',
    visaAdvisory: '签证咨询',
    visaApplication: '签证申请',
    travelServiceProviders: '旅行服务提供商',
    travelAgents: '旅行代理',
    visaAssistance: '签证协助',
    membership: '会员',
    support: '客服支持',
    faq: '疑问'
  },
  home: {
    southernAfrica: '南非',
    southernAfricaDesc: '南部非洲的20个难忘体验',
    eastAfrica: '东非',
    eastAfricaDesc: '东非必看的 21 件事',
    turkey: '土耳奇',
    turkeyDesc: '奇妙的Türkiye：东方与西方交融之地',
    redefineTheJourney: '重新定义旅程',
    saleEnds: '还有',
    discoverSouthAmerica: '探索南美',
    Star5ToursatUnbeatablePrices: '五星级旅游，超值价格',
    star5Toursat: '五星级旅游',
    unbeatablePrices: '超值价格',
    japan: '日本',
    japanDesc: '日本经典初访之旅',
    readOurBlog: '阅读我们的博客',
    egypt: '埃及',
    egyptDesc: '尼罗河、沙漠与神圣之地：埃及的永恒魅力',
    taiwan: '台湾',
    taiwanDesc: '从都市灯火到神圣遗址及更远的旅程',
    peru: '秘鲁',
    peruDesc: '穿越时光与文化的旅程',
    toursTogo: '自由行',
    toursTogoDesc:
      '探索 Tours ToGo 旅游选项，包括全陪团、半自助团和豪华团。每种旅行方式都提供独特体验，从全程导览到更具灵活性的行程。机票不包含，但可以轻松添加，以定制您的旅行体验。',
    flexiblePackages: '灵活套餐',
    trustedPartners: '值得信赖的合作伙伴',
    globalDestinations: '全球目的地',
    easyPlanning: '轻松规划',
    costEffective: '高性价比',
    discoverMore: '探索更多',
    productCollectionType: '产品集合类型',
    tripToGoTourCollections: 'TripToGo 精选跟团游',
    tripToGoTourCollectionsDesc:
      '安心体验由 TripToGo 精心挑选、并由值得信赖的旅游合作伙伴运营的行程。与其他 TripToGo 会员同行，享受兼顾品质、价值与顺畅体验的精选路线。',
    joinInGroupTour: '拼团跟团游',
    ttgCollection: 'TTG 精选',
    joinInGroup: '拼团',
    joinInGroupTourDesc:
      '加入由值得信赖的当地旅游合作伙伴设计及运营的共享团。同行旅客也可能来自 TripToGo 社区之外，让您结识更多不同的人，并获得更多出发日期选择。',
    tripToGoPackageCollections: 'TripToGo 精选套餐',
    tripToGoPackageCollectionsDesc:
      'TripToGo 与值得信赖的旅游合作伙伴共同设计，提供精心规划的路线、精选酒店和特色体验，让您深入感受目的地魅力。适合希望一次获得当地特色与顺畅行程安排的旅客。',
    joinInGroupPackages: '拼团旅游套餐',
    joinInGroupPackagesDesc:
      '由值得信赖的旅游合作伙伴运营，套餐包含机票、酒店及经典常规体验。适合希望轻松获得高性价比组合、无需额外定制的旅客。',
    packageToGo: '旅游套餐',
    packageToGoDesc:
      '轻松旅行，从我们的“机票+酒店”套餐开始。预订往返机票和酒店，一次搞定，简化您的旅程。享受一站式预订，轻松启程。',
    flightsIncluded: '包含机票',
    multipleDestinations: '多目的地',
    destinationConcierge: '目的地礼宾服务',
    upgradableHotels: '可升级酒店',
    curatedTours: '精心策划的旅行',
    recommended: '推荐',
    recommendedDesc: '我们的旅行专家团队精选了五个目的地，承诺为您带来独特的体验、令人叹为观止的景色和难忘的回忆，专属于我们的会员。',
    newslettersToGo: '订阅我们',
    newslettersToGoDesc: '订阅获取促销、奖励和旅行灵感，助您开启下一次 TripToGo 之旅！',
    dontMiss: '您不想错过的精彩',
    traverNetwork: 'TripToGo 旅行者网络',
    referAFriend: '推荐好友',
    earnUpTo: '赚取高达',
    Rewards100: '$100 奖励',
    earnNow: '立即赚取',
    tripToGoMembership: 'TripToGo 会员',
    earnUpTo100: '赚取高达 100 积分奖励',
    discoverPeru: '探索秘鲁',
    discoverPeruDesc: '揭开印加帝国的秘密，领略安第斯山脉的壮丽风光。',
    adventureAlliance: '探险联盟',
    adventureAllianceDesc: '召集 10 人或以上的团队，共同踏上难忘的旅程！',
    recentlyViewed: '最近浏览的优惠',
    theTripToGoDifference: 'TripToGo 的独特之处',
    whatTravelersSay: 'TripToGo 旅行者评价',
    enterEmail: '输入邮箱',
    differ_1: '客户关怀',
    differDesc_1:
      '我们提供 24/7 全天候支持，快速解决问题，致力于为客户和供应商提供无缝、优质的体验。',
    differ_2: '直接连接',
    differDesc_2:
      '我们将旅行者直接连接到全球目的地、专家和旅行合作伙伴，一站式统一平台。',
    differ_3: '透明定价',
    differDesc_3:
      '我们提供透明定价，无隐藏费用，通过长期直接的旅游行业合作为您带来独家优惠。',
    differ_4: '全面解决方案',
    differDesc_4:
      'TripToGo 是一站式平台，提供个性化旅行规划和无缝便捷的预订体验。',
    differ_5: '前瞻思维',
    differDesc_5:
      '先进技术驱动无缝预订、智能连接和 AI 个性化推荐，持续提升 TripToGo 旅行体验。',
    featured1: '精选',
    featured2: '目的地',
    weekly_1: '每周精选优惠',
    weeklyDesc_1:
      '每周，我们精心挑选全球最佳旅行优惠，为尊贵会员带来超值折扣。精选内容涵盖热门目的地和独特体验，助您创造难忘回忆。',
    weekly_2: '热门趋势',
    weeklyDesc_2: '我们的数据驱动算法为您呈现当前最受关注的热门旅行优惠。',
    weekly_3: '惊喜特惠抢购',
    weeklyDesc_3: '优惠瞬息万变，随时回来查看！',
    weekly_4: '独家特权',
    weeklyDesc_4:
      '解锁独家特权优惠，仅限 Voyager 和 Elite 会员！享受精选顶级目的地与体验的超值折扣，让您的下一次旅行更加精彩！',
    weekly_mystery: '旅游盲盒',
    weeklyDesc_mystery: '预订神秘惊喜旅行 — 付款后揭晓目的地。已有数百名旅行者勇敢迈出这一步！',
    searchDesc: '敬请期待这一激动人心的新功能，即将上线！',
    allCountry: '所有国家',
    selectDate: '选择日期',
    whereTo: '去哪儿',
    subscriptionFailed: '订阅失败',
    subscriptionSuccessful: '订阅成功',
    weeklyHours: '时',
    weeklyMins: '分',
    aboutUs: '关于我们',
    aboutUsDesc: '了解更多关于我们的愿景和价值观。',
    readMore: '了解更多',
    trustpilot: 'Trustpilot',
    googleReviewTitle: 'TripToGo 旅行者的真实评价',
    writeReview: '撰写评论',
    needSome: '需要一些',
    inspirations: '灵感',
    featuredDestSubtitle: '阅读我们最新的灵感、冒险和旅行贴士，为您的下一次旅行做准备。',
    readAllBlogs: '查看所有博客',
    travelerStoriesTitle: '旅行者故事',
    travelerStoriesSubtitle: '观看我们旅行者的真实旅程故事与体验',
    learnMore: '了解更多',
    watchMoreVideos: '观看更多视频',
    mins: '分钟',
    bookNow: '立即预订',
    trustpilot: 'Trustpilot'
  },
  hotelDeal: {
    promoTitle: '会员专属酒店优惠',
    bookNow: '立即预订',
    checkIn: '入住日期',
    checkOut: '退房日期',
    roomType: '房型',
    roomsCount: '房间数',
    adults: '成人',
    guestName: '宾客姓名',
    nationality: '国籍',
    confirmAndPay: '确认并付款',
    bookingConfirmed: '预订已确认',
    viewDeal: '查看优惠 →',
    saveUpTo: '最高节省 {n}%',
    fromPerNight: '每晚低至 {price}'
  },
  mysteryBox: {
    formTitle: '选择您的行程信息',
    formSub: '请选择出发月份和出行人数。',
    departureMonth: '出发月份',
    selectDepartureDate: '请选择出发年月',
    selectDepartureMonth: '请选择出发月份。',
    selectDepartureCity: '请选择出发城市。',
    nationality: '国籍',
    selectNationality: '请选择国籍',
    travelerN: '旅客 {n}'
  },
  login: {
    earnPoints: /*html*/ `登录，分享您的代码，并赚取 <span style="color: #4ca771">100 积分！</span>`,
    logIn: '登录',
    forgotPassword: '忘记密码？',
    createAnAccount: '创建账户',
    dontHave: '还没有账户？',
    success: '登录成功',
    successDesc: '成功！您已登录您的账户。请关闭此窗口并继续操作。'
  },
  recover: {
    enterEmail: '邮箱不能为空',
    recoverMyPassword: '找回我的密码',
    recoverYourPassword: '找回您的密码',
    desc: '请输入您创建账户时使用的电子邮件地址，我们将向您发送一个临时密码。',
    successDesc: '成功！临时密码已发送至您的电子邮件，请关闭此窗口并继续登录。'
  },
  register: {
    sendCodeTips: '验证码已发送到您的电子邮件和电话号码',
    title: '创建账户',
    already: '已经有账户？',
    successTitle: '',
    successDesc: '恭喜！您的账户已成功创建。您可以关闭此窗口并继续操作。',
    couponGranted:
      '🎁 作为欢迎礼,您获得了一张 {amount} 优惠券(券码:{code}),已存入您的账户,有效期 {days} 天。券码也已发送至您的邮箱。',
    agreeTxt: /*html*/ `我已阅读并同意 <span style="color: #1b80de; padding-left: 2px; text-align: left; line-height: 19px"><a href="/terms/?title=general" target="_blank" style="display: inline">条款与条件</a></span>，我愿意接收 TripToGo 提供的精彩旅行优惠和独家特惠信息。`,
    regSuccess: '注册成功！',
    noMatch: '请确保您的密码匹配'
  },
  detail: {
    hotelsExperienceUpgrade: '酒店体验与升级',
    hotelsExperienceUpgradeDesc: `我们的酒店选择（经典、豪华、尊贵）依据可用性和季节性安排。在您的入住期间，您可能会被分配到同等标准的酒店。`,
    viewDatesPrices: '查看日期和价格',
    agentSellingPoints: '代理销售要点',
    playVideo: '播放视频',
    KannaGuide: 'Kanna 指南',
    viewGallery: '查看图库',
    believeDesc: `我们致力于为会员提供最优价值和透明定价。我们的旅行专家团队与值得信赖的合作伙伴达成独家协议，并对比市场价格，为您带来最佳价值。在 TripToGo，您将获得清晰的比价、真实的优惠，并确保自己做出最明智的旅行选择。`,
    totalSavings: '总节省金额（最高可达）',
    marketPrice: '市场价格',
    trustedPartner: '值得信赖的合作伙伴',
    exclusiveOn: 'TripToGo 独家',
    saveUpTo: '最高可节省',
    scoopDesc: `*我们的价格反映了发布时的最佳可用优惠。由于旅行优惠可能随时变动，请注意价格和详情可能会有所调整，但我们始终会努力为您提供最新信息。`,
    bookNow: '立即预订',
    bookingTutorial: '预订指南',
    finalHour: '最后机会！以折扣价预订您的梦想之旅！',
    bookWithoutFlights: '仅预订行程（不含机票）',
    bookWithFlights: '预订行程 + 机票',
    redeemWithFlights: '兑换行程 + 机票',
    askOperator: '咨询运营商',
    topThingsToSee: '必看景点',
    whatToExpect: '旅行期待',
    WhatsIn: '包含内容',
    WhatsOut: '不包含内容',
    tripItinerary: '行程计划',
    downloadFlyer: '下载宣传单',
    downloadItinerary: '下载行程单',
    expandAllDays: '展开所有天数',
    collapseAllDays: '收起所有天数',
    tripBy: '行程提供方',
    youMightAlsoLike: '您可能还喜欢',
    travelTips: '旅行贴士',
    domesticFerry: '国内渡轮',
    ferryRides: '渡轮航程',
    atFamousIslands: '著名岛屿游览',
    niceReviews: '好评',
    domesticAirfare: '国内机票',
    beijingToShanghai: '北京至上海',
    withinHalfAnHour: '半小时内',
    withinOneHour: '一小时内',
    withinTwoHour: '两小时内',
    days4AndMore: '4 天及以上',
    insideScoop: '内部资讯',
    selectADay: '选择一天',
    selectADayToGo: '选择一天以继续',
    selectYourDepartureCity: '选择出发城市',
    selectADate: '选择日期',
    mysteryNoRedeemDates: '您的盲盒兑换月份暂无可选出发日期，请联系我们，或尝试不含机票兑换。',
    enterYourCity: '输入您的出发城市',
    clickADate: '点击日期在线预订',
    datesPrices: '日期和价格',
    setLeftOnly: '仅剩',
    setLeft: '座位',
    pleaseSelectADate: '请选择日期',
    todoSorry: '抱歉，航班不可用，请联系我们的销售代表。',
    limited: '有限',
    soldOut: '售罄',
    bestPrice: '最低',
    priceDrop: '降价',
    regular: '常规',
    rescheduled: '重新安排',
    reservationInProgress: '预订进行中',
    addMoreRooms: '加更多房间',
    shareDetail: '分享详情给朋友！',
    enterYourfriendEmail: '输入您朋友的电子邮件地址',
    enterYName: '输入您的姓名',
    enterYEmail: '输入您的电子邮件地址',
    enterYFName: '输入您朋友的姓名',
    enterYFEmail: '输入您朋友的电子邮件',
    enterMessage: '输入留言',
    shareSuccess: '行程分享成功',
    shareSuccessDesc: '成功！您已成功将此行程分享给您的朋友。请关闭此窗口并继续操作。',
    sentSuccess: '消息发送成功！感谢您的分享！',
    fillInName: '请填写您的姓名！',
    fillInEmail: '请填写您的电子邮件！',
    fillInFName: '请填写您朋友的姓名！',
    fillInFEmail: '请填写您朋友的电子邮件！',
    wrongEmail: '您的电子邮件格式错误！',
    wrongFEmail: '您朋友的电子邮件格式错误！',
    bookingInquiries: '预订咨询！',
    bookingInquiriesDesc: '对行程有疑问？请在下方给运营商留言，他们将在 48 个工作小时内回复您。',
    expectedTravelDate: '预计出行日期',
    max: '最多 ',
    iHaveQuestion: '我有关于以下内容的问题',
    pleaseDesc: '请描述您的问题',
    questionSentSuccess: '问题已成功发送！',
    questionSentSuccess1: '您的问题已成功发送',
    questionSentSuccess2: '将尽快回复您。您可以在“我的资料”下的“我的咨询”中跟进您的对话。',
    pleaseQuestion: '请填写问题。',
    pleaseEnterQuestion: '请填写合适长度的问题',
    sentQuestionSuccess: '发送成功，感谢你的支持！',
    age0_2: '对于0 - 2 岁的儿童，请联系我们的旅行专家。',
    yourItineraryIsReady: '您的行程已准备就绪！',
    itineraryDesc1: '输入您的电子邮件以获取',
    itineraryDesc2: '行程直送至您的收件箱。',
    itineraryAgree: '我同意通过电子邮件接收 TripToGo 的独家优惠信息。',
    itinerarySent: '行程成功发送！',
    itinerarySentDesc: '请检查您的收件箱，如有任何疑问，请随时联系我们。'
  },
  about: {
    about: '关于',
    whoWeAre: '关于我们',
    whoeWeAreDesc:
      'TripToGo 是一个专属会员平台，利用前沿技术简化并优化度假规划。凭借 30 多年的行业经验和无与伦比的合作关系，我们为全球目的地提供难忘的旅行体验。我们最大的乐趣就是为挑剔的会员打造一生难忘的旅程。',
    ourMission: '我们的使命',
    ourMissionDesc:
      '我们相信旅行应该对每个人都可及，无论是初学者还是经验丰富的旅行者。我们的使命是让每一次旅行变得轻松无忧。',
    ourVision: '我们的愿景',
    ourVisionDesc: '我们致力于彻底改变旅行者规划行程和探索世界的方式。',
    our: '我们的',
    approach: '方法',
    title1: '前瞻思维',
    desc1:
      '技术驱动着我们的一切。它支持我们的无缝预订平台和移动应用，让您能够随时联系导游、上传旅行文件、接收通知、获取和预订优惠，并分享您的照片和实时视频。通过 AI 驱动的市场和虚拟旅行顾问 Kanna，我们革新了旅行规划，提供个性化推荐和行程安排。我们专注于技术，以确保您今天的 TripToGo 体验卓越，未来更胜一筹。',
    title2: '客户关怀',
    desc2:
      '我们为客户提供卓越的 24/7 全天候支持团队，迅速解决问题，并致力于确保供应商和客户的顺畅体验。提供愉悦的旅行体验是我们的首要任务。',
    title3: '直接连接',
    desc3:
      '我们促成全球目的地、专家和文化体验的直接连接。在这里，您可以与专家、旅行者、酒店、航空公司、游轮公司和旅行社一站式互动。',
    title4: '透明定价',
    desc4:
      '我们提供清晰透明的定价，满足各种预算需求。凭借三十余年的行业经验，我们建立了直接的合作关系，为您带来其他平台可能无法提供的优惠。我们的模式消除了隐藏费用和溢价成本，让您直接获取来自旅游供应商的最优价格。',
    title5: '全面解决方案',
    desc5:
      'TripToGo 是一站式旅行规划与预订平台，提供个性化推荐和简化的预订流程，让旅行变得更加便捷。'
  },
  mmship: {
    mmshipRequired: '需要会员资格—原因如下！',
    joinUsToday: '立即加入我们！',
    weExcited: '我们很高兴为您提供独家旅行套餐。按照以下简单步骤加入我们的社区，开始享受专属福利：',
    weSecure:
      '我们通过强大的合作伙伴关系和不断升级的技术，为全球旅行者提供独家体验，带来无与伦比的价格和非凡的旅程——直连资源方！会员制度让这一切成为可能。最棒的是，您可以<b>随时取消，并获得未使用月份的退款</b>，<b>无自动续订</b>—完全由您掌控。',
    discoverTheBenefits: '探索会员福利',
    signup: '注册',
    logIn: '登录',
    paymentSuccessful: '支付成功',
    welcomeToTheTTG: '欢迎加入 TTG 大家庭！',
    enjoyAccess: '享受无与伦比的价格、独家会员福利等特权！立即开启您的梦想之旅！',
    continueBooking: '继续预订',
    directToProfilePage: '前往个人页面',
    membershipPolicy: '会员政策',
    membershipBenefits: '会员福利',
    seeDetails: '查看详情',
    welcomePoints: '欢迎积分',
    rewards: '奖励积分',
    cancelationProtection: '取消保障',
    weeklyDreamTripDraw: '每周梦想旅行抽奖',
    earlyAccess: '提前获取促销信息',
    exclusivePromotions: '专属促销',
    waivedTransactionFees: '免交易手续费',
    complimentaryUpgrades: '免费升级',
    welcomePackage: '欢迎礼包',
    birthdayFreebies: '生日福利',
    freeTrips: '免费旅行',
    bookOnTripToGo: '在 TripToGo 预订',
    deposit:  '免预付定金',
    annually: '每年',
    free: '免费',
    getStarted: '立即开始',
    changeTier: '降级',
    unlock: '解锁',
    unlockWhen: '积分达到 500 即可解锁',
    welcomePointsTip: '加入即可获得积分，兑换比例为 1 积分 = 1 美元。',
    rewardsTip: '每笔符合条件的预订均可赚取积分，用于抵扣未来旅行费用。',
    cancelationProtectionTip: '在余款到期前确认的请求可豁免标准取消费，保障您的资金安全。',
    weeklyDreamTripDrawTip: '会员每周可获得一次抽奖机会，有机会赢取免费梦想之旅。适用条款和条件。',
    earlyAccessTip: '优先获取限时优惠和热门座位的预订资格。',
    exclusivePromotionsTip: '享受专属折扣、代金券及旅行优惠。',
    complimentaryUpgradesTip: '享受免费升级及增值服务。',
    birthdayFreebiesTip: '生日当月享受专属礼品或特别旅行优惠。',
    freeTripsTip: '符合条件即可享受全额免费的旅行体验。',
    bookOnTripToGoTip: '访问仅通过我们平台提供的会员专属优惠。',
    welcomePackageTip: '抵达后将收到精心策划的礼品、茶点及客房惊喜。',
    waivedTransactionFeesTip: '免除标准信用卡及处理手续费，为您节省更多。',
    seeAllBenefits: '查看全部福利',
    collapse: '收起',
    close: '收起',
    bestValue: '最佳价值',
    memberNumber: '会员编号',
    availableUntil: '有效期至',
    renewMembership: '续订会员',
    pickYourPlan: '选择您的计划。我们为您提供合适的方案。',
    chooseYourMembershipPlan: '选择您的会员计划',
    ourPricingTables: '我们的定价表',
    elite: 'Elite',
    hello: '您好'
  },
  groupRegister: {
    organizeADream: '策划一场梦想假期',
    withAGroup: '与您最爱的伙伴一起',
    joinTripToGo: '加入 TripToGo 的探险联盟',
    rallyYour: '召集您的 10 人或以上团队，开启一场难忘的旅程！',
    unlockA:
      '作为旅行发起者，策划这次冒险并解锁丰厚奖励——您可以免费获得一个名额，或者每增加一位好友，就能享受更诱人的折扣！',
    assembleYour: '集结您的团队！',
    enlist10: '招募 10 人或以上的伙伴，一起享受团队旅行的专属福利。',
    bookYourTrip: '预订您的行程',
    bookYourTripDesc:
      '请提供您的联系方式，我们的专业顾问将与您联系，帮助您和您的团队预订理想行程。',
    saveBig: '超值优惠',
    saveBigDesc: '作为团队负责人，您可能有机会获得免费旅行，或让团队成员享受额外折扣。',
    primaryTravelerInformation: '主要旅行者信息',
    writeYourFirstName: '请输入您的名字',
    writeYourLastName: '请输入您的姓氏',
    writeYourEmail: '请输入您的电子邮件',
    adultsMore12: '成人（>12 岁）',
    children: '儿童（2-11 岁）',
    infants: '婴儿（<2 岁）',
    tripData: '行程信息',
    departureDate: '出发日期',
    iAmFlexibl: '我很灵活',
    iAmNotSure: '我不确定',
    selectRange: '选择日期范围',
    howMuchDoYou: '您希望每人花费多少？（不含机票）',
    howMuchDoYouIncluding: '您希望每人花费多少？（含机票）',
    selectCity: '选择城市',
    whereDoYouWantToGo: '您想去哪里？',
    selectDestination: '选择目的地',
    sendAMessage: '发送消息给我们的旅行专家。请包含您的问题、需求或其他备注。',
    writeYouMessageHere: '请在此输入您的留言',
    iHaveReadAndAgree: '我已阅读并同意',
    generalPolicy: '《通用政策》',
    send: '发送',
    successDesc: '恭喜！您的消息已成功发送。',
    from: '从',
    to: '到',
    notSure: '不确定'
  },
  withus: {
    welcome: '欢迎来到 TripToGo：重新定义旅行',
    welcomeDesc:
      'TripToGo 与全球领先的航空公司、酒店、邮轮公司、铁路和地面运营商合作，通过我们的前沿技术和 24/7 全天候支持渠道，提供丰富的旅行选择。我们的多样化计划、便捷的访问渠道和极具竞争力的价格，让您的旅行更加顺畅、安全，并带来前所未有的回报。',
    support24: '24/7 全天候支持',
    mutualGrowth: '共同成长',
    noHiddenFees: '无隐藏费用',
    famTrips: 'FAM 考察旅行',
    limitedTimeOffers: '限时优惠',
    extraPerks: '独家产品额外福利',
    jointPromotions: '联合促销和销售活动',
    excitedIncentive: '丰富的激励计划',
    ourGlobal: '我们的全球网络',
    bringingTheWorld: '与全球值得信赖的旅行合作伙伴携手，为您打造无缝的旅行体验',
    whyChoose: '为什么选择 TripToGo 作为您的首选合作伙伴？',
    readyToJoinUs: '准备好加入我们了吗？',
    registerEarly: '尽早注册，尽享专属福利',
    registerNow: '立即注册',
    hugeDatabase: '庞大的旅行者数据库',
    tailored: '定制旅行套餐',
    global: '全球曝光',
    postTravel: '旅行后客户互动',
    dynamic: '动态定价模式',
    strongSocial: '强大的社交媒体影响力',
    innovative: '结合 AI 的创新营销策略',
    exclusive: '独家专属优惠',
    trusted: '值得信赖的品牌声誉'
  },
  operatorReg: {
    registerAs: '注册为旅行服务提供商',
    thanksForYour: '感谢您对 TripToGo 的关注，我们期待与您共同成长！',
    joinTripToGo: '加入 TripToGo 成为旅行服务提供商',
    ifYourCompany: '如果您的公司运营自己的旅行团，并希望成为 TripToGo 的供应商，请在此注册。',
    alreadyRegistered: '已经注册？',
    ifYouHave: '如果您已有 TripToGo 账户或您的机构已注册，请登录或联系您的经理获取新的登录信息。',
    beforeWeCan:
      '在我们正式合作之前，您需要先注册成为运营商。如果您是旅行运营商，但尚未与 TripToGo 合作，请填写以下表格。注册通过后，您将能够为您的公司代理人提供个人访问权限。',
    nameOfTheLegal: '法律实体名称（将显示在佣金支票上）。',
    uploadLogoImage: '上传徽标图片',
    pleaseNote:
      '*请注意，我们需要一个注册号才能成功处理您的 TripToGo 申请。没有注册号，您的机构将无法获得批准。',
    operatorAddress: '运营商地址',
    operatorContact: '运营商联系方式',
    operatorEmail: '运营商电子邮件地址',
    supplierPhoneNumber: '供应商联系电话',
    agencyManager: '代理机构经理',
    holdUp: '注意！此处不是您的个人联系信息，而是您所在机构经理的联系方式。',
    other: '其他',
    iHaveRead: '我已阅读并同意条款与条件。',
    registerSuccess: '注册成功',
    registerSuccessDesc: '成功！您已成功注册。请关闭此窗口并继续操作。',
    americanSociety: '美国旅行社协会',
    codeUnitedState: '+1（美国）',
    codeCanada: '+1（加拿大）',
    CLIANumber: 'CLIA 号码',
    IATANumber: 'IATA 号码',
    TIDSNumber: 'TIDS 号码',
    ABTANumber: 'ABTA 号码',
    TICONumber: 'TICO 号码',
    nationalTour: '国家旅游协会',
    business: '商业注册号',
    socialMedia: '社交媒体',
    businessReferral: '商业推荐',
    google: 'Google/搜索',
    searchEngine: '搜索引擎',
    legalCompanyName: '法律公司名称',
    logo: '徽标',
    fillInYour: '填写您的注册号',
    address: '地址',
    country: '国家',
    selectNationality: '选择国籍',
    stateOrProvince: '州或省',
    stateProvince: '州/省',
    city: '城市',
    postalCode: '邮政/邮编',
    firstName: '* 名字',
    lastName: '* 姓氏',
    email: '* 电子邮件',
    userName: '* 用户名',
    companyWebsite: '公司网站',
    howDidYouHear: '您是如何了解到我们的'
  },
  agentReg: {
    title: '注册为旅行代理/旅行社',
    title2: '注册 TripToGo 既快捷又免费，并可享受以下福利。',
    fullCommissions: '全额佣金',
    onlineBooking: '24/7 全天候在线预订',
    onlineReservation: '在线预订、定价和预订管理',
    easyAccess: '轻松访问产品库存和可用性',
    makeAPayment: '付款',
    setPassword: '设置密码',
    newToTripToGo: '新用户？',
    createAnAccount: '立即创建账户！',
    Step1Of2: '第 1 步，共 2 步',
    yourInformation: '您的信息',
    mobilePhoneNumber: '手机号码',
    Step2Of2: '第 2 步，共 2 步',
    agencyInformation: '旅行社信息',
    agencyName: '旅行社名称',
    agencyAddress: '旅行社地址',
    agencyEmailAddress: '旅行社电子邮件地址',
    agencyWebsite: '旅行社网站',
    passwordsMatch: '请确保您的密码匹配。',
    invalidNumberFormat: '无效的号码格式',
    verify: '验证',
    save: '保存'
  },
  agentFaq: {
    gotSomeQuestion: '想了解如何与我们合作？',
    whyPartnerWith: '为什么选择与 TripToGo 合作',
    AccessTo24: '24/7 全天候聊天支持',
    connectWith: '随时联系代理支持，联系方式：',
    realTime: '实时库存管理',
    bookingManagement: '预订管理与报告',
    marketingLibrary: '营销资源库',
    bookingTools: '预订工具',
    FAMTrips: '提供 FAM 考察旅行',
    chooseYourDestination: '选择您的目的地',
    enterAll: '填写所有必填信息',
    bookYourTrip: '预订您的行程',
    getThe: '获取确认号码',
    agentFAQ: '常见问题'
  },
  contact: {
    contactNumber: '联系电话',
    writeYourMessage: '写下您的留言',
    agentWriteYourMessage: '填写您的代理协助请求',
    message: '留言',
    location: '地点',
    canadaOffice: '加拿大办公室',
    address1_1: '675 Cochrane Dr, East Tower Suite 302',
    address1_2: 'Markham, ON L3R 0B8',
    USAOffice: '美国办公室',
    address2_1: '590 Madison Ave, 21st Floor',
    address2_2: 'New York City, NY 10022',
    officeHours: '办公时间',
    AMToPM: '上午9:30 至 下午5:30（周一至周五）',
    generalInquiries: '一般咨询',
    agentGeneralInquiries: '旅行社咨询',
    haveAQquestion: '有问题吗？',
    yourMessageSent: '您的留言已发送！感谢您的支持！',
    contactUs: '联系我们',
    agentContactUs: '联系我们：<BR>旅行代理支持与合作'
  },
  visa: {
    ifYouNeed: '如果您需要帮助，请拨打 1-877-908-9878。',
    australia: '澳大利亚',
    argentina: '阿根廷',
    brazil: '巴西',
    cambodia: '柬埔寨',
    canada: '加拿大',
    china: '中国',
    cuba: '古巴',
    cyprus: '塞浦路斯',
    ecuador: '厄瓜多尔',
    egypt: '埃及',
    europe: '欧洲',
    fiji: '斐济',
    hongKong: '香港',
    india: '印度',
    indonesia: '印度尼西亚',
    japan: '日本',
    kenya: '肯尼亚',
    malaysia: '马来西亚',
    maldives: '马尔代夫',
    mexico: '墨西哥',
    morocco: '摩洛哥',
    newZealand: '新西兰',
    peru: '秘鲁',
    philippines: '菲律宾',
    singapore: '新加坡',
    slovakia: '斯洛伐克',
    southKorea: '韩国',
    sriLanka: '斯里兰卡',
    taiwan: '台湾',
    thailand: '泰国',
    turkiye: '土耳其',
    unitedArabEmirates: '阿拉伯联合酋长国',
    unitedKingdom: '英国',
    US: '美国',
    vietnam: '越南',
    visaRequirement: '签证要求'
  },
  faq: {
    frequentlyAsked: '常见问题',
    goBackToHomepage: '回到首页',
    myAccount: '我的账户'
  },
  insurance: {
    quoteUnavailable: '保险公司无法提供报价，请检查每位旅客的信息后重试。',
    travelerAgeLimitExceeded: '该旅客超过此保险计划承保的最高年龄。',
    theArchRoamRight_1: 'Arch RoamRight 旅行保护计划由 Arch 保险公司承保。',
    here: '这里',
    theArchRoamRight_2: '',
    archInsurancecompany: 'Arch 保险公司与 TripToGo 是独立实体，没有公司隶属关系。'
  },
  partner: {
    whyPartnerWith1: '为什么与',
    whyPartnerWith2: '合作',
    whatsInIt: '对您有什么好处',
    savings: '节省成本',
    boostExposure: '提升曝光度',
    audienceData: '受众数据和目标营销',
    increasedBookings: '增加预订量和收入'
  },
  mine: {
    personalInformation: '个人信息',
    agencyID: '代理编号',
    memberNumber: '会员编号',
    changePassword: '修改密码',
    infoSuccess: '成功！您的信息已成功更改。',
    pwdSuccess: '成功！您的密码已成功更改。',
    fillOldPassword: '请填写旧密码',
    filePassword: '请填写新密码',
    confirmPassword: '请确认您的密码',
    passwordNotMatch: '您确认的密码不匹配',
    updateSuccessfully: '更新成功！',
    travelersNetwork: '网络推广',
    partnerVintageProgram: '合作伙伴',
    password: {
      changePassword: '更改密码',
      SMSVerification: '短信验证',
      sendCode: '发送验证码',
      yourTelephone: '您的电话号码',
      SMSCode: '短信验证码',
      oldPassword: '旧密码',
      newPassword: '新密码',
      yourNewPassword: '请输入您的新密码',
      confirmYourPassword: '确认您的密码',
      successfully: '您的密码已成功更改。',
      enterNewPassword: '请填写您的新密码',
      enterTelephone: '请输入您的电话号码。',
      enterSMSCode: '请输入您的短信验证码',
      resendCode1: '',
      resendCode2: '秒后重发'
    },
    menu: {
      welcome: '欢迎',
      logout: '退出'
    },
    wish: {
      yourFavorites: '你的收藏，全在一个地方！',
      keeyTrackOf: '在这里追踪你的顶级目的地和必做活动。',
      viewDetails: '查看详情'
    },
    bookings: {
      myBookings: '我的预订',
      accessAllYour: '在一个地方访问所有预订详情',
      bookingID: '预订编号',
      refundInfo: '退款信息',
      copySuccessful: '复制成功',
      groupLink: '团体链接',
      detail: '详情'
    },
    groupLink: {
      linkBooking: '链接预订',
      travelingWithFriends: '和朋友或家人一起旅行？将您的预订链接在一起！',
      totalTravelers: '团体中的总旅行者人数',
      yourGroupLinkOrder: '您的团体链接订单',
      unlinkThisGroup: '取消此团体链接订单',
      unlink: '取消链接',
      link: '链接',
      ifYouHaveAGroup: '如果您有来自团体的代码，请输入并点击“链接”',
      ifYouDontHave: '如果您没有团体代码，请在此创建:',
      createNew: '创建新的'
    },
    wallet: {
      available: '可用的 TripToGo 积分',
      availableCoins: '可用的 TTG 积分',
      pointsPlainLabel: '积分',
      pointsCurrencyLabel: '奖励积分',
      YourWalletDetails: '您的钱包详情',
      issueDate: '发行日期',
      pointsEarned: '获得的积分',
      referral: '推荐',
      redeemedDate: '兑换日期',
      redeemedPoints: '兑换的积分',
      appliedTowards: '用于',
      availablePoints: '可用积分',
      of500RewardPoints: ' / 500.00',
      travelMore: '多旅行，多赚积分',
      unlockYour: '用TTG积分解锁您的下一次TripToGo！',
      from: '来自',
      earn: '赚取',
      repeat: '重复',
      redeem: '兑换',
      backToMyWallet: '返回我的钱包',
      expirationDate: '过期日',
      issued: '已处理',
      refunded: '已退款',
      refundedAmount: '退款金额',
      receivedAmount: '入账金额',
      giftCardRedeemed: '礼品卡兑换',
      paymentDate: '支付日期',
      availableFund: '可用金额',
      cardWithdrawalCutoffDate: '原卡提现截止日期',
      cardWithdrawalCutoffTooltip: '如果您希望将 TTG Coins 提现到原支付卡，可在原付款日期起 18 个月内完成。超过 18 个月后，金额将通过支票发放。请注意，可能会产生交易手续费和邮寄费用。',
      appliedToBooking: '用于预订',
      withdrawCard: '提现（信用卡）',
      withdrawCheck: '提现（支票）',
      withdrawalPendingCard: '提现待处理（信用卡）',
      withdrawalPendingCheck: '提现待处理（支票）',
      withdrawnCard: '已提现（信用卡）',
      withdrawnCheck: '已提现（支票）',
      withdrawalCancelledCard: '提现已取消（信用卡）',
      withdrawalCancelledCheck: '提现已取消（支票）',
      pendingWithdrawal: '待处理提现',
      withdrawn: '已提现',
      used: '已使用',
      available: '可用',
      pending: '待处理',
      cancel: '取消',
      expire: '已过期',
      withdraw: '提现',
      // Withdrawal related translations
      ttgCoinsWithdrawal: 'TTG 积分提现',
      withdrawalDescription: 'TTG 积分可用于其他消费。如您希望将 TTG 积分提现至原支付卡，需在原付款日起18个月内完成。超过18个月后，金额将以支票形式发放。请注意，可能会收取交易手续费和邮寄费用。',
      withdrawalReviewNotice: '所有提现申请均需审核，审核及处理通常需要 4–6 周。',
      withdrawalAvailableSince: '可提现日期',
      toOriginalCard: '退回原支付卡',
      byMailingCheck: '邮寄支票',
      withdrawalAmount: '提现金额',
      enterAmount: '请输入金额',
      invalidAmount: '请输入有效金额',
      amountTooSmall: '提现金额过小，无法处理，请重试。',
      amountExceedsBalance: '提现金额不能超过您的积分余额。',
      cardTransferNote: '金额将退回至信用卡',
      payToOrderOf: '收款人',
      payeeNamePlaceholder: '支票收款人全名',
      mailingAddress: '邮寄地址',
      mailingAddressPlaceholder: '请输入邮寄地址',
      requiredField: '此字段为必填项',
      acceptPolicy: '我已接受',
      refundPolicy: '退款政策',
      back: '返回',
      submit: '提交',
      confirmation: '确认',
      cardWithdrawalAmountExceeds: '输入金额超过当前可退回原支付卡的余额。',
      checkWithdrawalAmountExceeds: '输入金额超过当前可邮寄支票的余额。',
      refreshAndTryAgain: '当前页面信息已过期，请刷新后重试。',
      withdrawalTryAgainLater: '当前无法提交提现申请，请稍后重试。',
      confirmIntro: '请确认以下信息：',
      transferToCard: '退回至信用卡',
      mailByCheck: '邮寄支票',
      payableTo: '收款人',
      mailingTo: '邮寄至',
      transactionFee: '交易手续费',
      mailingFee: '邮寄费用',
      totalWithdrawalAmount: '提现总金额',
      confirm: '确认',
      processing: '处理中...',
      successful: '成功！',
      withdrawalRequestSubmitted: '提现申请已提交',
      successMessage: '您的提现申请已提交审核，相关 TTG Coins 已预留。审核及处理通常需要 4–6 周。目前尚未完成原支付卡退款。您可以在“我的钱包”中查看申请状态。',
      partialSuccessMessage: '您的提现申请已提交审核，相关 TTG Coins 已预留。审核及处理通常需要 4–6 周。目前尚未完成信用卡退款或支票付款。您可以在“我的钱包”中查看申请状态。',
      autoCardProcessingFailedMessage: '您的提现申请已提交审核。原支付卡退款暂时未能自动完成，但该申请已记录，后续会由我们的团队继续处理。审核及处理通常需要 4–6 周。',
      error: '错误',
      errorMessage: '抱歉，发生了意外错误。请与我们联系。',
      goToHelpdesk: '前往帮助中心',
    },
    inquiry: {
      gotQuestions: '有问题吗？我们有答案！',
      weAreHere1: '我们在这里帮助您规划所有旅行。无论您需要关于预订、目的地、',
      weAreHere2: '还是其他任何问题的详细信息，只需给我们留言，我们会尽快回复您。',
      operatedBy1: '由',
      operatedBy2: '运营',
      message: '消息',
      messages: '消息列表',
      enquiryDetails: '咨询详情',
      haveQuestionsAbout: '对旅游有疑问吗？请在下方给运营商留言，他们将在48个工作小时内回复您。'
    },
    helpDesk: {
      bookingHelpdesk: '预订帮助台',
      haveQuestionsAbout: '对旅游有疑问吗？请在下方给运营商留言，他们将在48个工作小时内回复您。',
      TTGTravelExpert: 'TTG旅行专家',
      rateReply: '您觉得最近一次回复如何？',
      ratingScale: '一至五星评分',
      ratingFeedback: '可选：填写对这次回复的意见',
      saveRating: '保存评分',
      savingRating: '正在保存…',
      ratingThanks: '感谢您的反馈。',
      ratingError: '评分保存失败。'
    },
    story: {
      travelInspireEarn: '旅行、启发与赚取',
      myStories: '我的故事',
      draftAStory: '起草一个故事',
      published: '已发布',
      pending: '待审核'
    },
    draft: {
      myStories: '我的故事',
      title: '标题',
      regionProvince: '地区/省份',
      selectStateProvince: '选择州/省份',
      photos: '照片（最多上传9张照片）',
      uploadPhotos: '上传照片',
      publish: '发布',
      congratulations: '恭喜！！！',
      thankYouForTraveling: '感谢您与我们一起旅行！您的旅行故事已上传。',
      seeMyStories: '查看我的故事',
      goBackToHomepage: '返回首页'
    },
    network: {
      shareYourLink: '分享您的链接',
      copyYourLink: '复制您的链接',
      emailYourInvite: '通过电子邮件发送邀请',
      sendByEmail: '发送邮件',
      howDoesItWork: '它是如何工作的？',
      step1: '步骤1',
      step2: '步骤2',
      step3: '步骤3',
      aFriendRegistersWithUs: '朋友在我们这里注册',
      itsAWin: '双赢',
      referrals: '推荐',
      creationDate: '创建日期',
      statusOfReward: '奖励状态',
      shareSuccDesc: '成功！我们已向您的朋友发送了一封电子邮件。',
      yourFriendsEmail: '你朋友的邮箱'
    },
    newsletter: {
      newsletter: '通讯',
      newslettersToGo: 'ToGo通讯',
      wouldYouLike: '“您想加入我们的通讯以获取激动人心的更新和优惠吗？”',
      successful: '成功',
      thankYou: '感谢您的订阅！',
      thankYouAgain: '再次感谢您的订阅！',
      unsubscribed: '取消订阅成功',
      sorryToSeeYouGo: '很遗憾看到您离开！',
      hasBeenUnsubscribed: '已成功取消订阅。',
      youWillStill: '*您仍将收到有关您的预订和咨询的所有必要通讯。',
      subscribeAgain: '再次订阅',
      unsubscribedBy: '不小心取消订阅了？'
    },
    agentInfo: {
      travelAgentInfo: '旅行社信息',
      primaryContact: '主要联系人信息',
      companyName: '公司名称',
      agencyAdress: '代理机构地址',
      pseudoCityCode: '伪城市代码',
      accreditationNumbers: '认证编号',
      licenseNumber: '许可证号',
      companyAffiliations: '公司隶属关系',
      consortia: '联盟/旅游运营商/独立旅行顾问/旅行代理/总部/分公司',
      numberOfEmployees: '员工人数',
      annualSalesVolume: '年度销售额',
      agencyLogo: '代理机构标志',
      noImageUploaded: '未上传图片',
      mainLogo: '主标志',
      socialMediaHandle: '社交媒体账号',
      associatedAccounts: '关联账户',
      noAccountsFound: '未找到匹配的账户',
      showMoreAccounts: '显示其他 {count} 个账户',
      showMainAccount: '仅显示主账户',
      mainAccount: '主账户',
      addAccount: '添加账户',
      removeAccount: '移除',
      confirmRemoveAccount: '确定将此账户从公司移除吗？',
      regeneratePassword: '重新生成密码',
      confirmRegeneratePassword: '确定要为此账户生成新的临时密码吗？原密码将立即失效。',
      newTempPasswordLabel: '新的临时密码：',
      errorMessage: '出现错误，请重试。'
    },
    partner: {
      partnerVintage: '合作伙伴复古计划',
      attractiveIncentives: '吸引人的激励措施',
      professionalAndPrompt: '专业且迅速的支持',
      collaborativeSuccess: '合作共赢',
      vintageTiers: '复古等级',
      annualSalesRevenue: '年度销售收入 (美元)',
      baseIncentive: '基本激励',
      overrideBonus: '超额奖励',
      totalCommission: '总佣金',
      partnerVintageProgramy: '合作伙伴复古计划政策',
      annualSalesRevenue: '年度销售收入',
      baseIncentive: '基本激励',
      overrideBonus: '超额奖励',
      gogogo: '加油加油...',
      totalCommission: '总佣金',
      conditionsApply: '条款适用'
    }
  },
  social: {
    facebook: 'Facebook',
    x: 'X',
    youtube: 'Youtube',
    tiktok: 'Tiktok',
    instragram: 'Instragram',
    tiktok: 'Tiktok'
  },
  mobileNav: {
    home: '首页',
    aiChat: 'AI 对话',
    cart: '购物车',
    account: '我的账户',
    support: '客户支持'
  },
  travelExplorer: {
    nav: {
      about: '关于',
      howItWorks: '如何运作',
      contentGuidelines: '内容指南',
      claimRewards: '领取奖励',
    },
    hero: {
      title: 'Travel Explorer',
      subtitle: '分享您的旅程，赚取奖励',
    },
    earnings: {
      videoPoints: '视频 100 积分',
      photoPoints: '图文 50 积分',
      pointValue: '1 积分 = 1 美元',
      maxPerTrip: '每次预订最多 300 积分',
      validPeriod: '积分有效期 1 年',
    },
    howItWorks: {
      title: '如何运作',
      videoCard: {
        title: '视频投稿',
        points: '100 积分',
        spec: '15–60 秒',
        description: '在社交媒体上分享您的旅行视频体验。',
      },
      photoCard: {
        title: '图文投稿',
        points: '50 积分',
        spec: '3–10 张高质量图片',
        description: '发布带有说明的旅行图文内容。',
      },
      pointSystem: {
        title: '积分体系',
        conversionLabel: '1 积分 = 1 美元',
        maxLabel: '每次预订最多 300 积分',
        expiryLabel: '积分有效期 1 年',
      },
    },
    guidelines: {
      title: '内容指南',
      pillar1: {
        title: '格式选择',
        description: '选择适合您内容的格式。动态体验使用视频，风景亮点使用图文。',
      },
      pillar2: {
        title: '关键词整合策略',
        description: '在帖子中包含必填标签以获得积分资格。',
        requiredTags: '必填标签：#TripToGo #Destination #review',
        captionExampleLabel: '文案示例',
        captionExample: '刚从 [目的地] 旅行回来，与 @triptogo_usa 合作！[亮点] 真的令人叹为观止。强烈推荐给寻找 [体验类型] 的旅行者。#TripToGo #Destination #review',
      },
      pillar3: {
        title: '官方账号标记',
        description: '标记我们的官方账号以便我们验证您的投稿。',
        tiktok: 'TikTok：@triptogo',
        instagram: 'Instagram：@triptogo_usa',
        facebook: 'Facebook：@triptogo.usa',
        youtube: 'YouTube：@TripToGo_explore',
      },
      tips: {
        title: 'TripToGo 小贴士',
        craftingTitle: '撰写引人入胜的评价',
        craftingBody: '专注于真实时刻、真诚的看法和具体细节，帮助其他旅行者做决策。提到让旅行特别的地方——导游、酒店、隐秘的宝藏地点——您的内容会更有共鸣，获得更多关注。',
      },
    },
    claimSteps: {
      title: '领取您的奖励',
      step1: {
        title: '收集材料',
        description: '收集您的帖子链接、显示个人主页和帖子的截图，以及您的 TripToGo 会员 ID。',
      },
      step2: {
        title: '发送投稿',
        description: '将所有材料发送至 shareyourjourney@triptogo.com，邮件主题：「Content Creator Points - [您的会员 ID]」。',
      },
      step3: {
        title: '验证与审核',
        description: '我们的团队将在 2–3 个工作日内审核您的投稿，确认其符合内容指南要求。',
      },
      step4: {
        title: '积分到账',
        description: '审核通过后，积分将在 5 个工作日内添加至您的账户。结账时使用 Bonus Points 抵扣订单金额。',
      },
      redeemInfo: '在结账时兑换积分。访问您的钱包查看积分余额。',
      contactEmail: 'shareyourjourney@triptogo.com',
    },
    social: {
      title: '下一站去哪里？用 TripToGo 记录您的旅行！',
      hashtags: '#TripToGo #Destination #review',
      cta: '立即开始赚取',
    },
  },
}
